'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memberCompliance = require('./member-compliance.html');

var _memberCompliance2 = _interopRequireDefault(_memberCompliance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _memberCompliance2.default,
  bindings: {
    compliantCompanies: '<',
    nonCompliantCompanies: '<'
  },
  controller: function MemberComplianceComponent() {
    'ngInject';

    _classCallCheck(this, MemberComplianceComponent);
  }
};


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.component.js